export function getTranslation(lang: string): {
    username: string;
    password: string;
    login: string;
    register: string;
    registerAccount: string;
    forgot: string;
    or: string;
} {
    const translationStrings = {
        en: {
            username: 'username',
            password: 'password',
            login: 'Log in',
            register: 'Register',
            registerAccount: 'Register an account',
            forgot: 'Forgot',
            or: 'or'
        },
        es: {
            username: 'Nombre de usuario',
            password: 'Contraseña',
            login: 'Iniciar sesión',
            register: 'Registrarse',
            registerAccount: 'Registrar una cuenta',
            forgot: 'Olvidé mi',
            or: 'o'
        }
    }
    return translationStrings[lang];
}
